module.exports = __webpack_public_path__ + "img/left_2.f6accfb0.jpg";